export default __webpack_public_path__ + "static/media/logoFooterMb.680d7a19.png";